import { Component, type ErrorInfo, type ReactNode } from "react";

type Props = { children: ReactNode };
type State = { error: Error | null; info: string };

// Видимый перехват ошибок — чтобы вместо белого экрана (особенно в Telegram)
// показать текст ошибки и можно было прислать скриншот.
export class ErrorBoundary extends Component<Props, State> {
  state: State = { error: null, info: "" };

  static getDerivedStateFromError(error: Error): Partial<State> {
    return { error };
  }

  componentDidCatch(_error: Error, info: ErrorInfo) {
    this.setState({ info: info.componentStack ?? "" });
  }

  render() {
    if (!this.state.error) return this.props.children;
    return (
      <div
        style={{
          padding: 16,
          fontFamily: "monospace",
          fontSize: 12,
          color: "#ffb4b4",
          background: "#1a0d0d",
          minHeight: "100dvh",
          whiteSpace: "pre-wrap",
          wordBreak: "break-word",
          overflow: "auto",
        }}
      >
        <div style={{ fontWeight: "bold", marginBottom: 8, fontSize: 14 }}>⚠️ Ошибка приложения</div>
        <div style={{ marginBottom: 8 }}>{String(this.state.error?.message || this.state.error)}</div>
        <div style={{ color: "#ff8080", fontSize: 11 }}>{String(this.state.error?.stack || "").slice(0, 1500)}</div>
        <div style={{ color: "#cc7070", fontSize: 10, marginTop: 8 }}>{this.state.info.slice(0, 800)}</div>
      </div>
    );
  }
}
